import { render } from "./health.vue?vue&type=template&id=2cd69544&scoped=true&ts=true"
import script from "./health.vue?vue&type=script&lang=ts"
export * from "./health.vue?vue&type=script&lang=ts"

import "./health.vue?vue&type=style&index=0&id=2cd69544&lang=less&scoped=true"

import exportComponent from "D:\\work\\project\\mobile-mpe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd69544"]])

export default __exports__